import { z } from 'zod';

export const post3ds2SuccessResponse = z.discriminatedUnion('acs', [
  z.object({
    acs: z.literal('0'),
  }),
  z.object({
    acs: z.literal('1'),
    redirectUrl: z.string(),
  }),
  z.object({
    acs: z.literal('2'),
    redirectUrl: z.string(),
  }),
]);
export type Post3ds2SuccessResponse = z.infer<typeof post3ds2SuccessResponse>;

export const post3ds2ErrorResponse = z.object({
  code: z.string(),
  message: z.string(),
  details: z.array(
    z.object({
      gmoErrorCode: z.string(),
    })
  ),
});
export type Post3ds2ErrorResponse = z.infer<typeof post3ds2ErrorResponse>;

export const post3ds2ResponseBody = z.union([
  post3ds2SuccessResponse,
  post3ds2ErrorResponse,
]);
export type Post3ds2ResponseBody = z.infer<typeof post3ds2ResponseBody>;

export type Methods = {
  post: {
    reqHeaders: {
      Authorization: string;
    };
    reqBody: {
      cardSeq: string;
      redirectSuccessUrl: string;
      redirectErrorUrl: string;
    };
    resBody: Post3ds2ResponseBody;
  };
};
